import { gql } from '@apollo/client';

export const CREATE_SURVEY = gql(/* GraphQL */ `
    mutation CreateSurvey($input: CreateSurveyInput!) {
        createSurvey(input: $input) {
            surveys {
                id
                advertisingZoneId
                advertisingZone {
                    id
                    name
                }
                storeId
                store {
                    id
                    name
                    storeNo
                }
                dueBy
                status
                championUserId
                championUser {
                    id
                    firstName
                    lastName
                }
                createdAt
            }
            errors {
                advertisingZoneId
                storeId
                message
            }
        }
    }
`);

export const REASSIGN_SURVEY_CHAMPION = gql(/* GraphQL */ `
    mutation ReassignSurveyChampion($input: ReassignSurveyChampionInput!) {
        reassignSurveyChampion(input: $input) {
            id
            championUserId
            championUser {
                id
                firstName
                lastName
            }
        }
    }
`);

export const CANCEL_SURVEY = gql`
    mutation CancelSurvey($input: CancelSurveyInput!) {
        cancelSurvey(input: $input) {
            id
            status
        }
    }
`;

export const UPDATE_SURVEY_ITEM_PRICE = gql(/* GraphQL */ `
    mutation UpdateSurveyItemPrice($input: UpdateSurveyItemPriceInput!) {
        updateSurveyItemPrice(input: $input) {
            id
            price
            notes
            recordedAt
        }
    }
`);

export const BULK_UPDATE_SURVEY_ITEM_PRICES = gql(/* GraphQL */ `
    mutation BulkUpdateSurveyItemPrices(
        $input: BulkUpdateSurveyItemPricesInput!
    ) {
        bulkUpdateSurveyItemPrices(input: $input) {
            success
            updatedCount
            updatedPrices {
                id
                surveyItemId
                priceSurveyCompetitorId
                price
                isNA
                recordedAt
            }
            errors {
                priceId
                message
            }
        }
    }
`);

export const SUBMIT_SURVEY_TO_DIVISIONAL_MANAGER = gql(/* GraphQL */ `
    mutation SubmitSurveyToDivisionalManager($surveyId: String!) {
        submitSurveyToDivisionalManager(surveyId: $surveyId) {
            id
            status
        }
    }
`);

export const GENERATE_SURVEY_PROOF_UPLOAD_URLS = gql(/* GraphQL */ `
    mutation GenerateSurveyProofUploadUrls(
        $input: GenerateSurveyProofUploadUrlInput!
    ) {
        generateSurveyProofUploadUrls(input: $input) {
            urls
        }
    }
`);
export const CREATE_PROOF_OF_SURVEY_COMPETITOR_PRICING = gql(/* GraphQL */ `
    mutation CreateProofOfSurveyCompetitorPricing(
        $input: CreateSurveyCompetitorProofInput!
    ) {
        createProofOfSurveyCompetitorPricing(input: $input) {
            id
            priceSurveyCompetitorId
            fileName
            fileSize
            fileType
            downloadUrl
            createdAt
        }
    }
`);
export const DELETE_SURVEY_COMPETITOR_PROOF = gql(/* GraphQL */ `
    mutation DeleteSurveyCompetitorProof($proofId: String!) {
        deleteSurveyCompetitorProof(proofId: $proofId)
    }
`);

export const UPDATE_SURVEY_ITEM_PROPOSED_PRICE = gql(/* GraphQL */ `
    mutation UpdateSurveyItemProposedPrice(
        $input: UpdateSurveyItemProposedPriceInput!
    ) {
        updateSurveyItemProposedPrice(input: $input) {
            success
            updatedCount
            updatedItems {
                id
                proposedSellingPrice
                approvedForPriceChange
                isDeclinedForPriceChange
                declinedReason
            }
            errors {
                surveyItemId
                message
            }
        }
    }
`);

export const SYNC_SURVEY_COMPETITOR_PRICES = gql(/* GraphQL */ `
    mutation SyncSurveyCompetitorPrices(
        $input: SyncSurveyCompetitorPricesInput!
    ) {
        syncSurveyCompetitorPrices(input: $input) {
            success
            competitorsAdded
            competitorsRemoved
            pricesUpdated
        }
    }
`);

export const CREATE_PCR_FROM_SURVEY_ITEM = gql(/* GraphQL */ `
    mutation CreatePcrFromSurveyItem(
        $input: SubmitDivisionalManagerSurveyInput!
    ) {
        createPcrFromSurveyItem(input: $input) {
            success
            partialSuccess
            surveyId
            surveyStatus
            pcrsCreated
            itemsMarkedNA
            createdPcrs {
                surveyItemId
                priceChangeRequestId
                sku
                isAutoDeclined
                autoDeclineReason
            }
            errors {
                surveyItemId
                message
            }
        }
    }
`);

export const PREPOPULATE_SURVEY_COMPETITOR_PRICES = gql(/* GraphQL */ `
    mutation PrepopulateSurveyCompetitorPrices($surveyId: String!) {
        prepopulateSurveyCompetitorPrices(surveyId: $surveyId) {
            success
            updatedCount
        }
    }
`);

export const PREPOPULATE_SURVEY_DM_REVIEW = gql(/* GraphQL */ `
    mutation PrepopulateSurveyDmReview($surveyId: String!) {
        prepopulateSurveyDmReview(surveyId: $surveyId) {
            success
            updatedCount
        }
    }
`);
